import { ComponentPropsWithRef, ForwardedRef } from "react";
import * as styles from "./style";
import video_mp4 from "../../../../static/whowatch_soundlogo.mp4";
import video_webm from "../../../../static/whowatch_soundlogo.webm";

interface LogoVideoProps extends ComponentPropsWithRef<"video"> {
  forwardRef?: ForwardedRef<HTMLVideoElement>;
}

export const LogoVideo = ({ forwardRef, ...props }: LogoVideoProps) => {
  return (
    <video
      css={styles.video}
      autoPlay
      muted
      playsInline
      ref={forwardRef}
      {...props}
    >
      <source src={video_webm} type="video/webM" />
      <source src={video_mp4} type="video/mp4" />
    </video>
  );
};
